import { globalEventBus, GameEvents } from '../core/EventBus.js';

/**
 * 计分板
 * 管理游戏分数
 */
export class ScoreBoard {
    constructor(config = {}) {
        this.config = {
            snapBonus: config.snapBonus || 10,
            timeBonus: config.timeBonus || 1000,
            rotationPenalty: config.rotationPenalty || 1
        };

        this.events = globalEventBus;

        // 分数状态
        this.score = 0;
        this.snappedCount = 0;
        this.rotationCount = 0;
        this.moveCount = 0;
    }

    /**
     * 添加吸附奖励
     */
    addSnapBonus() {
        this.snappedCount++;
        this.score += this.config.snapBonus;
        this.emitChange();
    }

    /**
     * 应用旋转惩罚
     */
    applyRotationPenalty() {
        this.rotationCount++;
        this.score = Math.max(0, this.score - this.config.rotationPenalty);
        this.emitChange();
    }

    /**
     * 记录移动
     */
    recordMove() {
        this.moveCount++;
    }

    /**
     * 计算时间奖励
     * @param {number} elapsedSeconds 用时（秒）
     * @returns {number} 时间奖励分数
     */
    calculateTimeBonus(elapsedSeconds) {
        // 时间越短奖励越高
        const bonus = Math.max(0, Math.floor(this.config.timeBonus / Math.max(1, elapsedSeconds / 60)));
        this.score += bonus;
        this.emitChange();
        return bonus;
    }

    /**
     * 添加自定义分数
     * @param {number} points 分数
     */
    addScore(points) {
        this.score += points;
        if (this.score < 0) this.score = 0;
        this.emitChange();
    }

    /**
     * 获取当前分数
     * @returns {number} 当前分数
     */
    getScore() {
        return this.score;
    }

    /**
     * 获取统计数据
     * @returns {Object} 统计数据
     */
    getStats() {
        return {
            score: this.score,
            snappedCount: this.snappedCount,
            rotationCount: this.rotationCount,
            moveCount: this.moveCount
        };
    }

    /**
     * 重置计分板
     */
    reset() {
        this.score = 0;
        this.snappedCount = 0;
        this.rotationCount = 0;
        this.moveCount = 0;
        this.emitChange();
    }

    /**
     * 发送分数变更事件
     */
    emitChange() {
        this.events.emit(GameEvents.SCORE_CHANGED, this.getStats());
    }

    /**
     * 格式化分数显示
     * @returns {string} 格式化的分数
     */
    getFormattedScore() {
        return this.score.toLocaleString();
    }

    /**
     * 更新配置
     * @param {Object} config 新配置
     */
    updateConfig(config) {
        this.config = { ...this.config, ...config };
    }
}

export default ScoreBoard;
